import React from "react";

const HomeBanner = ({ masterConfigKey }) => {
  return (
    <div>
      {masterConfigKey && (
        <a href="/madhya-pradesh/mptak-baithak">
          {/* Desktop Banner: visible on md and up */}
          <img
            src={masterConfigKey?.desktopBannerUrl}
            alt="sponsor"
            className="hidden md:block w-full h-full "
          />

          {/* Mobile Banner: visible below md */}
          <img
            src={masterConfigKey?.mobileBannerUrl}
            alt="sponsor"
            className="block md:hidden w-full h-full"
          />
        </a>
      )}
    </div>
  );
};

export default HomeBanner;
